// TA-approver audit contract shared by the two program builders, the review
// page, and the summary rail.

/** Rate the server applies when MARK_FOR_AUDIT_BASE_PCT_HUMAN is not configured (tio-api#10525). */
export const DEFAULT_HUMAN_AUDIT_PCT = 10;

/** 0 counts as unset — populate_fields stamps the seeded 0 onto every new template
 * (tio-api#10529), and the disable switch is the only off-lever, so the rate never reads 0. */
export function isHumanAuditPctUnset(stored: unknown) {
  const pct = Number(String(stored ?? '').trim());
  return !Number.isFinite(pct) || pct <= 0;
}
